module.exports = __webpack_public_path__ + "static/media/checked-background.d08d363d.svg";